module.exports = __webpack_public_path__ + "images/assets/eb419132a89e96eeed7919e7aa4aa42f.svg";